import { AiFillGithub, AiFillYoutube } from "react-icons/ai";
import { netdroidLogo, pdfunlockerLogo, tempmailLogo, pdfreducerLogo, fastsshLogo } from './images';

export const menu = [
  { name: "About" },
  { name: "Skills" },
  { name: "Services" },
  { name: "Projects" },
  { name: "Contact" },
]

export const projects = [
  {
    id: 1,
    title: 'NetDroid – All Network Tools',
    image: netdroidLogo,
    category: "Apps",
    rating: 4.2,
    data: {
      description: `Your all-in-one network toolkit with 25+ powerful tools including Speed Test, Ping, WiFi Analyzer, Port Checker, DNS Lookup, Traceroute, and more. Perfect for network administrators and tech enthusiasts who need reliable diagnostics on the go.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnar.netdroid",
    },
  },
  {
    id: 2,
    title: 'PDF Unlocker',
    image: pdfunlockerLogo,
    category: "Apps",
    rating: 3.4,
    data: {
      description: `Unlock password-protected PDF files instantly and offline. Remove restrictions from secured PDFs to enable printing, copying, and editing. A simple, fast, and privacy-focused utility — no internet connection required.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnarservers.pdfunlocker",
    },
  },
  {
    id: 3,
    title: 'Temp Mail - Disposable Email',
    image: tempmailLogo,
    category: "Apps",
    rating: 5.0,
    data: {
      description: `Create temporary email addresses instantly with no signup required. Protect your privacy from spam and unwanted emails. Features include auto-delete after 12 hours, multiple domain support, custom email prefix, and full attachment support. Available on both Android & iOS.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnar.tempmailget",
      iosLink: "https://apps.apple.com/us/app/temp-mail-tempmailget/id6775561862",
    },
  },
  {
    id: 4,
    title: 'PDF & Photo Size Reducer KB',
    image: pdfreducerLogo,
    category: "Apps",
    rating: null,
    data: {
      description: `Compress PDF and photo file sizes to your exact target KB — fast, offline, and private. Set an exact target size in KB and hit the limit every time for uploads. Supports batch compression and works entirely on-device with no internet required.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnar.pdfphotoreducer",
    },
  },
  {
    id: 5,
    title: 'FastSSH V2Ray',
    image: fastsshLogo,
    category: "Apps",
    rating: 4.2,
    data: {
      description: `A multi-protocol accounts generator and manager for VMess, VLESS, Trojan, SSH WebSocket, and Slow DNS. Check server status, generate accounts, and manage connections — all in a clean, easy-to-use Android interface. 1K+ downloads.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnar.fastsshv2ray",
    },
  },
  {
    id: 6,
    title: 'TempMailGet',
    image: 'https://www.tempmailget.com/favicon.svg',
    category: "Web",
    rating: null,
    data: {
      description: `A free temporary email web service — generate disposable email addresses instantly without registration. Receive emails privately, protect your real inbox, and stay organized. Works with any website. Mobile-friendly with attachment support.`,
      demoLink: "https://tempmailget.com/",
    },
  },
  {
    id: 7,
    title: 'Ragnar Servers',
    image: 'https://i.postimg.cc/3RdyrSCv/snapedit-1736771901291.png',
    category: "Community",
    rating: null,
    data: {
      description: `The Ragnar Servers Telegram channel is a central hub for tech enthusiasts, providing high-speed internet configuration files, premium service giveaways, and exclusive tech content. No shortened links — just direct, smooth access to everything you need.`,
      demoLink: "https://t.me/ragnarservers",
    },
  },
]

export const experience = [
  {
    title: "Mobile Development",
    data: [
      { skill: "Java / Kotlin", level: "Advanced" },
      { skill: "Android SDK", level: "Advanced" },
      { skill: "Firebase", level: "Experienced" },
      { skill: "Play Console", level: "Advanced" },
      { skill: "REST APIs", level: "Experienced" },
      { skill: "Material Design", level: "Experienced" },
    ],
  },
  {
    title: "Web Development",
    data: [
      { skill: "React.js", level: "Experienced" },
      { skill: "JavaScript", level: "Experienced" },
      { skill: "HTML / CSS", level: "Advanced" },
      { skill: "Node.js", level: "Intermediate" },
      { skill: "Next.js", level: "Intermediate" },
      { skill: "Responsive Design", level: "Advanced" },
    ],
  },
  {
    title: "Tools & Platforms",
    data: [
      { skill: "Git / GitHub", level: "Experienced" },
      { skill: "Telegram Bot API", level: "Advanced" },
      { skill: "Linux / VPS", level: "Experienced" },
      { skill: "Vercel / Hosting", level: "Experienced" },
      { skill: "Figma", level: "Intermediate" },
      { skill: "SEO Optimization", level: "Experienced" },
    ],
  },
]

export const socialHandles = [
  {
    name: "Github",
    icon: <AiFillGithub />,
    link: "https://github.com/AnimeHolic",
  },
  {
    name: "Youtube",
    icon: <AiFillYoutube />,
    link: "https://www.youtube.com/@RagnarServers",
  },
];
